export default "__VITE_ASSET__BAJWBkfO__"